import { render, staticRenderFns } from "./RsaPazienteProgettoPriListComponent.vue?vue&type=template&id=a24bc71e"
import script from "./RsaPazienteProgettoPriListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteProgettoPriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports